import lists from '../lists';

const listPassportViews = {
    ...lists,
    query: [{ key: 'type', value: 'passportViews' }],
} as const;

export default listPassportViews;
